import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { LoginGuard } from './guards/login.guard';

const routes: Routes = [
	{
		path: '',
		redirectTo: 'home',
		pathMatch: 'full'
	},
	{
		path: 'login',
		loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule),
		canActivate: [LoginGuard]
	},
	{
		path: 'recover',
		loadChildren: () => import('./pages/recover/recover.module').then(m => m.RecoverPageModule),
		canActivate: [LoginGuard]
	},
	{
		path: 'home',
		loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
		canActivate: [AuthGuard]
	},
	{
		path: 'dashboard',
		loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardPageModule),
		canActivate: [AuthGuard]
	},
	{
		path: 'players',
		loadChildren: () => import('./pages/players/players.module').then(m => m.PlayersPageModule),
		canActivate: [AuthGuard]
	},
	{
		path: 'convocations',
		loadChildren: () => import('./pages/convocations/convocations.module').then(m => m.ConvocationsPageModule),
		canActivate: [AuthGuard]
	},
	{
		path: 'chats',
		loadChildren: () => import('./pages/chats/chats.module').then(m => m.ChatsPageModule),
		canActivate: [AuthGuard]
	},
	{
		path: 'videos',
		loadChildren: () => import('./pages/videos/videos.module').then(m => m.VideosPageModule),
		canActivate: [AuthGuard]
	},
	{
		path: 'ranking',
		loadChildren: () => import('./pages/ranking/ranking.module').then(m => m.RankingPageModule),
		canActivate: [AuthGuard]
	},
	{
		path: 'notifications',
		loadChildren: () => import('./pages/notifications/notifications.module').then(m => m.NotificationsPageModule),
		canActivate: [AuthGuard]
	},
	{
		path: 'database',
		loadChildren: () => import('./pages/database/database.module').then(m => m.DatabasePageModule),
		canActivate: [AuthGuard]
	},
	{
		path: 'users',
		loadChildren: () => import('./pages/users/users.module').then(m => m.UsersPageModule),
		canActivate: [AuthGuard]
	},
	{
		path: 'settings',
		loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsPageModule),
		canActivate: [AuthGuard]
	},
	{
		path: 'cron',
		loadChildren: () => import('./pages/cron/cron.module').then(m => m.CronPageModule),
		canActivate: [AuthGuard]
	},
	{
		path: 'invitations',
		loadChildren: () => import('./pages/invitations/invitations.module').then(m => m.InvitationsPageModule),
		canActivate: [AuthGuard]
	},
	{
		path: 'reports',
		loadChildren: () => import('./pages/reports/reports.module').then( m => m.ReportsPageModule)
	},
	{
		path: 'events',
		loadChildren: () => import('./pages/scouting/events/events.module').then( m => m.EventsPageModule),
		canActivate: [AuthGuard]
	},
	{
		path: 'event',
		loadChildren: () => import('./pages/scouting/event/event.module').then( m => m.EventPageModule),
		canActivate: [AuthGuard]
	}

];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
	],
	exports: [RouterModule]
})
export class AppRoutingModule { }
